import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import SearchMagnifyIcon from 'views/ui/icons/search-magnify-icon';

import { Theme } from '../../theme';

const searchIconStyle = css`
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
  color: ${Theme.colors.line};
  fill: ${Theme.colors.line};
  font-size: 16px;
`;

const searchIconLeftStyle = css`
  right: auto;
  left: 15px;
  width: 24px;
  height: 24px;
`;

export const Search = styled('div')`
  position: relative;
  width: 100%;
  i {
    ${searchIconStyle};
    cursor: pointer;
  }
`;

export const SearchIcon = styled(SearchMagnifyIcon)`
  ${searchIconStyle};
  ${(props) => props.iconLeft && searchIconLeftStyle};
`;

const Input = styled('input')`
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${(props) => (props.iconLeft ? '45px' : '10px')};
  padding-right: ${(props) => (props.iconLeft ? '10px' : '45px')};
  box-sizing: border-box;
  border: 1px solid ${Theme.colors.inputs.border};
  border-radius: 0px;
  font-size: 14px;
  background: white;
  height: ${(props) => props.iconLeft && '100%'};

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${Theme.colors.inputs.placeholder};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: ${Theme.colors.inputs.placeholder};
  }
`;

const defaultProps = {
  value: '',
  placeholder: 'Placeholder',
  onChange: () => {},
  onEnter: () => {},
  onClear: () => {},
  onBlur: () => {},
  onFocus: () => {},
};

const SearchInput = ({
  className,
  value,
  placeholder,
  onChange,
  onEnter,
  onClear,
  onBlur,
  onFocus,
  dataTestId,
  iconLeft = false,
}) => {
  const onSearchChange = (e) => {
    e.preventDefault();
    onChange(e.target.value);
  };

  const onSearchClear = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClear();
  };

  let icon = <SearchIcon iconLeft={iconLeft} />;
  if (value.length > 0 && !iconLeft) {
    icon = <i className="icon af-close" onClick={onSearchClear} />;
  }

  return (
    <Search className={className}>
      {icon}
      <Input
        value={value}
        placeholder={placeholder}
        onChange={onSearchChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onEnter();
          }
        }}
        onBlur={onBlur}
        onFocus={onFocus}
        iconLeft={iconLeft}
        data-testid={dataTestId}
      />
    </Search>
  );
};

SearchInput.defaultProps = defaultProps;
export default SearchInput;
